import { useLocation } from 'wouter';
import { NavLink, NavLinkProps } from '@mantine/core';
import { Env } from '../Env.ts';
import { MouseEvent } from 'react';
import { getIcon, isActive } from './Helpers.tsx';
import { MenuItemWithoutChildren } from './Menu.tsx';
import { useMenuStyles } from './UseMenuStyles.tsx';

export function NavLinkWithoutChildren({
    collapsed,
    menuItem,
}: {
    collapsed?: boolean;
    menuItem: MenuItemWithoutChildren;
}) {
    const { classes } = useMenuStyles();
    const [, setLocation] = useLocation();
    const label = collapsed ? '' : menuItem.label;
    const icon = getIcon(menuItem.icon);
    const propsForLink: NavLinkProps = {
        sx: menuItem.sx,
        label,
        classNames: classes,
        icon,
    };
    if (menuItem.handler) {
        Object.assign(propsForLink, {
            onClick: menuItem.handler,
            target: '_blank',
            component: 'a',
        });
    }
    if (menuItem.newTab) {
        Object.assign(propsForLink, {
            href: menuItem.newTab,
            target: '_blank',
            component: 'a',
        });
    }

    if (menuItem.legacyUrl) {
        const href = `${Env.LEGACY_DOMAIN}${menuItem.legacyUrl}`;
        Object.assign(propsForLink, {
            href,
            component: 'a',
        });
    }

    if (menuItem.url) {
        Object.assign(propsForLink, {
            href: menuItem.url,
            component: 'a',
            onClick: (event: MouseEvent<HTMLButtonElement>) => {
                event.preventDefault();
                if (menuItem.url) setLocation(menuItem.url);
            },
            className: isActive(menuItem.url) ? 'active' : undefined,
        });
    }
    return (
        <NavLink
            key={menuItem.label}
            title={menuItem.label}
            {...propsForLink}
        />
    );
}
